import {
  date,
  notValue,
  nullable,
  pipe,
  string,
  transform,
  union
} from 'valibot'

import { VALIDATION_MESSAGES } from '@/constants/common/validation.constants'

// Date→string型への変換を含む、日付のnon-nullableなスキーマ
// union([date(), string()]) により、valibotResolver が transform 後の string を
// フォーム値に書き戻しても再検証で失敗しない
export const nonNullableDateToStringSchema = pipe(
  nullable(union([date(), string()])),
  transform((v) =>
    v instanceof Date ? v.toISOString() : typeof v === 'string' && v ? v : ''
  ),
  notValue('', VALIDATION_MESSAGES.REQUIRED_ITEM)
)
